import { createContext } from "react";

/**
 * @typedef {Object} Route
 * @property {string} parentPath - The parent route path
 * @property {string} path - The route path
 * @property {React.ReactElement} element - The React component to render
 * @property {boolean} [index] - Whether this is an index route
 * @property {React.ReactElement} [icon] - Icon for the route
 * @property {string} [title] - Title of the route
 * @property {string} [description] - Description of the route
 * @property {boolean} [isNativeRoute] - Defines if the route is by default a part of the application
 * @property {boolean} [ignoreRendering] - Whether to ignore rendering this route in the navbar
 * @property {Route[]} [nestedRoutes] - Nested routes
 */
/**
 * @typedef {Object} RouteManagerContextValue
 * @property {function(Array<Route>, string|Array<string>): Array<Route>} excludeRoutes - Function to exclude routes from an array
 * @property {Array<Route>} AuthRoutes - Authentication routes
 * @property {Array<Route>} AppRoutes - Application routes
 * @property {React.ReactElement} NotFoundRoute - 404 route element
 * @property {Object} Current - Current route data and URL utilities
 * @property {(primaryTitle: string, secondaryTitle: string, promoText: string) => void} updatePageMeta - Updates the title and meta description of the page
 * @property {Route & {modify: function(Object): Route}|null} Current.route - Function to get current route data
 * @property {function(): {getUrl: function(Object): string}} Current.url - Function that returns URL utilities
 */
// Create RouteManager Context

/**
 * @type {React.Context<RouteManagerContextValue | null>}
 */
const RouteManagerContext = createContext();

export default RouteManagerContext;
